<template>
    <rkm-form
        v-if="model"
        ref="RkmForm"
        show-legend
    >
        <rkm-row>
            <rkm-col cols="5">
                <rkm-form-date-picker
                    range
                    :range-inline="false"
                    start-label="Período de"
                    end-label="Até"
                    :start-validations="validations.inicio"
                    :end-validations="validations.fim"
                    :max-date="additionals.dataAtual"
                    v-model="model.periodo"
                />
            </rkm-col>

            <rkm-col class="flex-grow-1">
                <rkm-form-input
                    disabled
                    label="Unidade"
                    v-model="form.unidadeLogada"
                />
            </rkm-col>

            <rkm-col class="flex-grow-1">
                <rkm-form-input
                    disabled
                    label="Local de atendimento"
                    v-model="form.localAtendimentoLogado"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="2">
                <rkm-form-select
                    :options="form.servicos"
                    @change="handleServico()"
                    defaultOptionText="Todos"
                    label="Serviço"
                    show-default-option
                    text-field="nome"
                    v-model="model.servicoId"
                    value-field='id'
                />
            </rkm-col>
            
            <rkm-col cols="2">
                <rkm-form-select
                    :options="form.faixasEtarias"
                    @change="handleFaixaEtaria()"
                    defaultOptionText="Todos"
                    label="Perfil de atendimento"
                    show-default-option
                    text-field="nome"
                    v-model="model.faixaEtariaId"
                    value-field='id'
                />
            </rkm-col>

            <rkm-col cols="4">
                <rkm-form-select
                    :options="getUsuarios"
                    defaultOptionText="Todos"
                    label="Profissional"
                    show-default-option
                    text-field="nome"
                    v-model="model.usuarioId"
                    value-field='id'
                />
            </rkm-col>

            <rkm-col>
                <rkm-form-input
                    type="number"
                    label="Número da FAA"
                    v-model="model.faa"
                    :validations="validations.faa"
                />
            </rkm-col>

            <rkm-col cols="auto">
                <rkm-button
                    :label="false"
                    @click.stop="search"
                    color="primary"
                >
                    Buscar
                </rkm-button>

                <rkm-button
                    :label="false"
                    @click.stop="resetForm"
                >
                    Limpar
                </rkm-button>
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Mixins.
import { repository, error, data, object } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

// Moment.
import moment from 'moment'

export default {
    computed: {
        getUsuarios() {

            const usuarios = []

            this.form.usuarios.forEach(usuario => {
                if (!usuarios.find(u => u.id === usuario.id && u.lotacaoId === usuario.lotacaoId)) {

                    usuarios.push({
                        id: usuario.id,
                        nome: usuario.nome,
                        lotacaoId: usuario.lotacaoId,
                    })
                }
            })

            return usuarios
        },
        validations() {

            return {
                inicio: { required: !this.model.faa },
                fim: { required: !this.model.faa },
                faa: { required: false, min_value: 1 }
            }
        }
    },
    created() {

        this.repositories = {
            fechamentoFaa: this.getConectaSusRepository('prontoAtendimento.fechamentoFaa')
        }

        this.load()
    },
    data: () => ({
        form: null,
        model: null,
        additionals: null
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            this.repositories.fechamentoFaa.list()
                .then(({ data }) => {

                    this.form = data.form
                    this.model = data.model
                    this.additionals = data.additionals

                    this.setDefaultValues()

                    this.addPeriodoWatch()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        addPeriodoWatch() {

            this.$watch('model.periodo', {
                deep: true,
                handler(periodo) {

                    this.$nextTick()
                        .then(() => {

                            this.$refs.RkmForm.validateSilent()
                                .then(valid => {

                                    if (!valid) return

                                    this.setLoading()

                                    const filters = {
                                        start: this.getFormatedDate(periodo.start, 'DD/MM/YYYY'),
                                        end: this.getFormatedDate(periodo.end, 'DD/MM/YYYY'),
                                    }

                                    this.repositories.fechamentoFaa.list(filters)
                                        .then(({ data }) => {

                                            this.form = data.form

                                            this.model.servicoId = null
                                            this.model.usuarioId = null
                                        })
                                        .catch(this.handleError)
                                        .finally(() => {this.unsetLoading()})
                                })
                        })
                }
            })
        },
        resetForm() {

            this.form.servico = null

            this.$nextTick()
                .then(() => {

                    this.setDefaultValues()

                    return this.$nextTick()
                })
                .then(() => this.$refs.RkmForm.resetValidator())
        },
        setDefaultValues() {

            this.model.periodo.start = moment(this.form.dataAtual, 'DD/MM/YYYY').toDate()
            this.model.periodo.end = moment(this.form.dataAtual, 'DD/MM/YYYY').toDate()

            this.model.servicoId = null
            this.model.usuarioId = null
            this.model.faa = null
        },
        search() {

            this.$refs.RkmForm.validate()
                .then(valid => {

                    if (!valid) return

                    this.setLoading()
                    this.$emit('busy', true)

                    const filters = {
                        start: this.getFormatedDate(this.model.periodo.start, 'DD/MM/YYYY'),
                        end: this.getFormatedDate(this.model.periodo.end, 'DD/MM/YYYY'),
                        servico_id: this.model.servicoId,
                        faixa_etaria_id: this.model.faixaEtariaId,
                        usuario_id: this.model.usuarioId,
                        faa_id: this.model.faa,
                    }

                    this.repositories.fechamentoFaa.index(filters)
                        .then(({ data }) => {

                            data._timestamp = (new Date).getTime()

                            this.$emit('data', data)
                            this.$emit('periodo', this.clone(this.model.periodo))
                        })
                        .catch(this.handleError)
                        .finally(() => {
                            this.unsetLoading()
                            this.$emit('busy', false)
                        })
                })
        },
        handleServico() {

            if (this.model.periodo.start && this.model.periodo.end) {

                this.setLoading()

                const filters = {
                    start: this.getFormatedDate(this.model.periodo.start, 'DD/MM/YYYY'),
                    end: this.getFormatedDate(this.model.periodo.end, 'DD/MM/YYYY'),
                }

                if (this.model.servicoId) { filters.servico_id = this.model.servicoId }
                if (this.model.faixaEtariaId) { filters.faixa_etaria_id = this.model.faixaEtariaId }

                this.repositories.fechamentoFaa.list(filters)
                    .then(({ data }) => {

                        this.form.usuarios = data.form.usuarios
                        this.model.usuarioId = null
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        handleFaixaEtaria() {

            if (this.model.periodo.start && this.model.periodo.end) {

                this.setLoading()

                const filters = {
                    start: this.getFormatedDate(this.model.periodo.start, 'DD/MM/YYYY'),
                    end: this.getFormatedDate(this.model.periodo.end, 'DD/MM/YYYY'),
                }

                if (this.model.servicoId) { filters.servico_id = this.model.servicoId }
                if (this.model.faixaEtariaId) { filters.faixa_etaria_id = this.model.faixaEtariaId }

                this.repositories.fechamentoFaa.list(filters)
                    .then(({ data }) => {

                        this.form.usuarios = data.form.usuarios
                        this.model.usuarioId = null
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        }
    },
    mixins: [ repository, error, data, object ],
}
</script>